module.exports = __webpack_public_path__ + "media/images/redesign-images/home/design-flatlays/design-8-4672b808d4186caeedd1c3a740f9cd27.png";